(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.an-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.an-hero__dot'));
        this.index = 0;
        this.timer = null;
        if (this.slides.length < 2) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const prev = this.querySelector('.an-hero__prev');
        const next = this.querySelector('.an-hero__next');
        if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
        if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));

        let startX = null;
        this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) { this.go(this.index + (dx < 0 ? 1 : -1)); this.restart(); }
          startX = null;
        }, { passive: true });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) { this.go(i); this.stop(); this.editorLock = true; }
        };
        this.onBlockDeselect = (e) => {
          if (this.slides.indexOf(e.target) > -1) { this.editorLock = false; this.start(); }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      go(i) {
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.slides.forEach((slide, k) => {
          const active = k === this.index;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
            const lazy = slide.querySelector('img[loading="lazy"]');
            if (lazy) lazy.loading = 'eager';
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
          }
        });
        this.dots.forEach((dot, k) => {
          dot.classList.toggle('is-active', k === this.index);
          if (k === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        // Warm up the next slide's image so the fade never shows a blank frame on slow 3G.
        const upcoming = this.slides[(this.index + 1) % n].querySelector('img[loading="lazy"]');
        if (upcoming) upcoming.loading = 'eager';
      }

      start() {
        if (this.dataset.autoplay !== 'true' || this.reducedMotion || this.editorLock) return;
        if (!this.slides || this.slides.length < 2) return;
        this.stop();
        const speed = parseInt(this.dataset.speed, 10) || 5000;
        this.timer = window.setInterval(() => this.go(this.index + 1), speed);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
